module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/screen-macbook-casestudy-1d2b89fbe262919f09d7aa6a62ada263.png";